import React, { useState } from "react";
import {
  endInteraction,
  setcontactlist,
} from "../../../../Redux/Actions/actions";
import CircularProgress from "@mui/material/CircularProgress";
import { connect } from "react-redux";
import axios from "axios";
import {
  fileservice,
  fileSizeCofig,
} from "../../../../Container/BaseUrl/BaseUrl";
import { toast } from "react-toastify";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  Button,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import {
  FileDoc,
  FileJpg,
  FilePdf,
  FilePng,
  FileText,
  FileXls,
  Image,
  PlayCircle,
  Video,
  X,
  XCircle,
} from "@phosphor-icons/react";
import { toaststyle } from "../../../../Utils/toaststyle";
const allowedFormats = [
  "pdf",
  "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "vnd.openxmlformats-officedocument.wordprocessingml.document",
  "plain",
  "png",
  "jpeg",
  "mp4",
  "msword",
  "wav",
  "webmp",
  "mpeg",
  "webm"
];

const mapStateToProps = (state) => {
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
    externalChatData: state.data.externalChatData,
  };
};

const PreViewmodal = (props) => {
  const {
    showPreviewmodal,
    handleClose,
    uploadedFile,
    setuploadedFile,
    sendMessage,
  } = props;
  const [loader, setloader] = useState(false);

  const fileUpload = async (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    if (!file) return toast.error("Something Went Wrong", toaststyle);
    if (file.size >= fileSizeCofig) {
      event.target.value = "";
      toast.error("File Too Large", toaststyle);
      return;
    }
    setloader(true);
    const formData = new FormData();

    if (props.UploadFrom == "customerPortal") {
      let user_id = JSON.parse(localStorage.getItem("chatData"));
      formData.append("file", file);
      formData.append("userID", user_id.phonenumber);
      formData.append("clientApp", "InapiWebchat");
      formData.append("channel", "webchat");
      formData.append("sessionId", user_id.chat_session_id);
      formData.append("sentBy", "Customer");
    } else {
      const selectedChat = JSON.parse(localStorage.getItem("client"));
      const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
      formData.append("file", file);
      formData.append(
        "userID",
        selectedChat.chat_type == "external"
          ? selectedChat.unique_id.phonenumber
          : selectedChat.reciverDetails[0]._id == loggedInAgent.agent_id
            ? selectedChat.senderDetails[0]._id
            : selectedChat.reciverDetails[0]._id
      );
      formData.append("clientApp", "InapiWebchat");
      formData.append("channel", "webchat");
      formData.append("sessionId", selectedChat.chat_session_id);
      formData.append("sentBy", "Agent");
    }
    await axios
      .post(fileservice + "/fileServer/uploadMedia", formData, {
        headers: {
          "content-type": "multipart/form-data",
          tenantId: "123456",
        },
      })
      .then((res) => {
        console.log("file", res.data);
        if (res.data.status) {
          if (allowedFormats.includes(res.data.data.extension)) {
            const finalFile = {
              filename: file.name,
              fileType: res.data.data.extension,
              datetime: file.lastModifiedDate.toLocaleString("en-IN"),
              filesize: file.size,
              attachmentUrl: res.data.data.signedUrl,
            };
            setuploadedFile(finalFile);
            toast.success(res.data.message, toaststyle);
            setloader(false);
            event.target.value = "";
          }
        } else {
          toast.error(res.data.message, toaststyle);
          setloader(false);
          event.target.value = "";
        }
      })
      .catch((err) => {
        setloader(false);
        event.target.value = "";
        console.log("fileUpload", err);
      });
  };

  return (
    <Dialog
      open={showPreviewmodal}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        variant="subtitle2"
        sx={{
          fontSize: "14px",
          fontWeight: 600,
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        }}
      >
        File Upload
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Box
            className="mt-3"
            sx={{ display: "flex", justifyContent: "center", gap: 2 }}
          >
            {!uploadedFile && !loader && (
              <label className="custum-file-upload" for="file">
                <div className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill=""
                    viewBox="0 0 24 24"
                  >
                    <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                    <g
                      stroke-linejoin="round"
                      stroke-linecap="round"
                      id="SVGRepo_tracerCarrier"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        fill=""
                        d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                        clip-rule="evenodd"
                        fill-rule="evenodd"
                      ></path>
                    </g>
                  </svg>
                </div>
                <div className="text">
                  <span className="fs-13">Click to upload image</span>
                </div>
                <input type="file" id="file" onChange={fileUpload} />
              </label>
            )}

            {loader && (
              <Box sx={{ position: "relative", display: "inline-flex" }}>
                <CircularProgress />
              </Box>
            )}

            {uploadedFile && !loader && (
              <>
                <Box
                  p={2}
                  sx={{
                    backgroundColor: "#1976d117",
                    borderRadius: "7px",
                    width: "300px",
                    height: "100px",
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    width: "100%",
                  }}
                >
                  <Stack
                    p={1}
                    direction={"row"}
                    spacing={1}
                    alignItems={"center"}
                    sx={{
                      borderRadius: 1,
                    }}
                  >
                    {(() => {
                      switch (uploadedFile ? uploadedFile.fileType : "") {
                        case "pdf":
                          return <FilePdf size={40} />;
                        case "img":
                        case "png":
                        case "jpeg":
                          return <Image size={40} />;
                        case "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                          return <FileXls size={40} />;
                        case "vnd.openxmlformats-officedocument.wordprocessingml.document":
                          return <FileDoc size={40} />;

                        case "plain":
                          return <FileText size={40} />;
                        case "mp4":
                          return <Video size={40} />;
                        case "webm":
                          return <Video size={40} />;
                        case "msword":
                          return <FileDoc size={40} />;
                        case "wav":
                          return <PlayCircle size={40} />;
                        case "mpeg":
                          return <PlayCircle size={40} />;

                        default:
                          return <></>;
                      }
                    })()}

                    <Typography variant="caption2" className="fs-13">
                      {uploadedFile.filename}
                    </Typography>
                  </Stack>
                  <IconButton
                    size="small"
                    color="error"
                    sx={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                    }}
                    onClick={() => {
                      setuploadedFile(null);
                    }}
                  >
                    <XCircle size={22} />
                  </IconButton>
                </Box>
              </>
            )}
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ textTransform: "capitalize !important" }}
          variant="outlined"
          onClick={() => {
            handleClose();
          }}
          size="small"
          disableElevation
          color="error"
          autoFocus
        >
          Close
        </Button>

        {uploadedFile && (
          <Button
            sx={{ textTransform: "capitalize !important" }}
            variant="contained"
            onClick={() => {
              sendMessage();
              handleClose();
            }}
            size="small"
            disableElevation
          >
            Send
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default connect(mapStateToProps, {
  endInteraction,
  setcontactlist,
})(PreViewmodal);
